// extracted by mini-css-extract-plugin
export default {"section":"Idu0GMMZUQqRO2akGqct"};